import * as angular from 'angular';

import { ComponentDefinition } from '../../models/index';
import { ICurrentApplicationService, IstateDependencyService } from '../../services/index';

class ManualInputsButtonsController implements angular.IComponentController {
    hasValidation = false;
    hasApprobation = false;
    isLoading: boolean;
    loadingMessage: string;

    readonly isMobileMode: boolean;

    static $inject = [
        '$state',
        'stateDependencyService',
        'currentApplicationService'
    ];

    constructor(
        private _$state: angular.ui.IStateService,
        private _stateDependencyService: IstateDependencyService,
        private _currentApplicationService: ICurrentApplicationService
    ) {
    }

    $onInit() {
        this._stateDependencyService
            .getItems(this._$state.get('dataEntry'))
            .then(data => {
                this.hasValidation = !!data.items && !!data.items.length;
            });

        const app = this._currentApplicationService.getApplicationConfiguration();
        this.hasApprobation = (app) ? app.validationEnabled : false;
    }
}

export const wtManualInputsButtons: ComponentDefinition = {
    componentId: 'wtManualInputsButtons',
    controller: ManualInputsButtonsController,
    template: require('./manualInputsButtons.component.html'),
    controllerAs: 'vm',
    bindings: {
        isMobileMode: '<?'
    }
};